<template>
<div>
    <!-- modal -->
    <b-modal id="patentAnnuityEpoFormModal" centered size="lg" no-close-on-backdrop :cancel-title=" $t('others.cancel_title')" :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate" ref="patentAnnuityEpoFormModal" :title="$t('patentAnnuity.info')" @close="clear()">
        <validation-observer ref="infoRules" tag="form">
            <b-row>
                <b-col class="col-md-4 mt-1">
                    <b-form>
                        <validation-provider #default="{ errors }" :name="$t('patentAnnuity.year')" :rules="{ excluded: 0 }">
                            <label for="patent-annuity-year-input">{{ $t('patentAnnuity.year') }}</label>
                            <b-form-select v-model="yearSelect" value-field="id" text-field="name" size="sm" :options="yearOption" />
                            <b-form-invalid-feedback :state="errors.length > 0 ? false : null">
                                {{ errors[0] }}
                            </b-form-invalid-feedback>
                        </validation-provider>
                    </b-form>
                </b-col>
                <b-col class="col-md-4 mt-1">
                    <label for="patent-annuity-date-input">{{ $t('patentAnnuity.date') }}</label>
                    <CustomDatePicker :datePickerValidateOption="1" v-model="date"></CustomDatePicker>
                </b-col>
                <b-col class="col-md-4 mt-1">
                    <label for="patent-annuity-payment-date-input">{{ $t('patentAnnuity.payment_date') }}</label>
                    <CustomDatePicker :datePickerValidateOption="0" v-model="paymentDate"></CustomDatePicker>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-md-4 mt-1">
                    <label for="patent-annuity-installment-deadline-date-input">{{ $t('patentAnnuity.installment_payment_deadline_date') }}</label>
                    <CustomDatePicker :datePickerValidateOption="0" v-model="installmentPaymentDeadlineDate"></CustomDatePicker>
                </b-col>
                <b-col class="col-md-4 mt-1">
                    <b-form>
                        <validation-provider :name="$t('patentAnnuity.will_pay')" #default="{ errors }" :rules="{ excluded: 0 }">
                            <label for="language-input">{{ $t('patentAnnuity.will_pay') }}</label>
                            <b-form-select v-model="patentAnnuityWillPaySelect" value-field="id" text-field="name" size="sm" :options="patentAnnuityWillPayOption" />
                            <b-form-invalid-feedback :state="errors.length > 0 ? false : null">
                                {{ errors[0] }}
                            </b-form-invalid-feedback>
                        </validation-provider>
                    </b-form>
                </b-col>
                <b-col class="col-md-4 mt-1">
                    <b-form>
                        <label for="language-input">{{ $t('patentAnnuity.status') }}</label>
                        <b-form-select v-model="patentAnnuityStatusSelect" value-field="id" size="sm" text-field="name" :options="patentAnnuityStatusOption" />
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-md-12 mt-1">
                    <label for="textarea-default">{{ $t('patentAnnuity.explanation') }}</label>
                    <b-form-textarea id="textarea-default" :placeholder="$t('patentAnnuity.explanation')" v-model="explanation" rows="6" maxlength="150" />
                </b-col>
            </b-row>
        </validation-observer>
    </b-modal>
</div>
</template>

<script>
export default {
    props: {},
    data() {
        return {
            id: 0,
            patentId: 0,
            yearOption: [],
            yearSelect: 0,
            patentAnnuityWillPayOption: [],
            patentAnnuityWillPaySelect: 0,
            date: null,
            paymentDate: null,
            patentAnnuityStatusSelect: 0,
            patentAnnuityStatusOption: [],
            explanation: '',
            installmentPaymentDeadlineDate: null,
        }
    },
    methods: {
        showInfo(patentAnnuity) {
            if (patentAnnuity != null) {
                this.$refs['patentAnnuityEpoFormModal'].show()
                const controller = {
                    name: 'PatentAnnuity',
                    actionName: 'GetPatentAnnuityInfoForEpoXml'
                }
                const data = {}
                const payload = {
                    data: data,
                    controller: controller
                }
                let loader = this.$loading.show()
                this.$store.dispatch('moduleAuth/customServiceGet', payload).then((response) => {
                    if (response.data.resultStatus == true) {
                        this.yearSelect = patentAnnuity.year
                        this.date = patentAnnuity.date
                        this.yearOption = response.data.patentAnnuityYearList
                        this.patentAnnuityWillPayOption = response.data.patentAnnuityWillPayList
                        this.patentAnnuityStatusOption = response.data.patentAnnuityStatusList
                        this.patentAnnuityStatusSelect = 0
                        this.installmentPaymentDeadlineDate = patentAnnuity.installmentPaymentDeadlineDate
                        this.patentAnnuityWillPayOption.splice(0, 0, this.$nullSelected('name'))
                        this.patentAnnuityStatusOption.splice(0, 0, this.$nullSelected('name'))
                        if (patentAnnuity.patentAnnuityWillPayId > 0) {
                            this.patentAnnuityWillPaySelect = patentAnnuity.patentAnnuityWillPayId

                        } else {
                            this.patentAnnuityWillPaySelect = 0
                        }
                    }
                })
                loader.hide()

            }
        },
        async addOrUpdate() {
            await this.emitDesiredValues()
            this.$bvModal.hide('patentAnnuityEpoFormModal')
            this.clear()

        },
        emitDesiredValues() {
            var emitValue = {
                year: this.yearSelect,
                date: this.date,
                patentAnnuityWillPayId: this.patentAnnuityWillPaySelect,
                explanation: this.explanation,
                paymentDate: this.paymentDate,
                patentAnnuityStatusId: this.patentAnnuityStatusSelect,
                installmentPaymentDeadlineDate: this.installmentPaymentDeadlineDate
            }
            this.annuityEmitValue = emitValue
            this.$emit('annuityEmitValue', this.annuityEmitValue)
            return new Promise(resolve => setTimeout(resolve, 500));
        },
        clear() {
            this.yearOption = [],
                this.yearSelect = 0,
                this.patentAnnuityStatusSelect = 0,
                this.patentAnnuityStatusOption = [],
                this.patentAnnuityWillPayId = 0,
                this.patentAnnuityWillPayOption = [],
                this.patentAnnuityWillPaySelect = 0,
                this.explanation = '',
                this.paymentDate = null,
                this.date = null,
                this.installmentPaymentDeadlineDate = null
        }
    },
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}

.customList {
    border: 1px solid #999;
    padding: 20px;
}

.datepickerStyle {
    max-height: 2.2em;
    font-family: fangsong;
}
</style>
